import {  NgModule } from '@angular/core';
import { AcessoExternoRoutingModule } from './acesso-externo.routing.module';

import { 
  AcessoExternoComponent
} from './index.component';
import { SharedModule } from '@smdapp/shared';
import { NgSharedModule } from '@smdapp/ng-shared/ng-shared.module'
import { CommonModule } from '@angular/common';
import {ReCaptchaModule} from "angular2-recaptcha";
import { AcessoGovBrComponent } from '../acesso-gov-br/acesso-gov-br.component';

@NgModule({
  imports: [AcessoExternoRoutingModule, NgSharedModule, SharedModule, CommonModule, ReCaptchaModule],
  declarations: [
  AcessoExternoComponent, AcessoGovBrComponent
  ],
  providers: []
})
export class AcessoExternoModule {}
